import Image from 'next/image';
import { clsx } from 'clsx';

import amplitude from '../service/amplitude';
import { useMapCtaButtonImage } from '../services/use-map-cta-button-image';

import type { Distributor } from '@autopass-web/types';

interface MapCta2AppButtonProps {
  distributor: Distributor;
  onClick: () => void;
}

export const MapCta2AppButton = ({
  distributor,
  onClick,
}: MapCta2AppButtonProps) => {
  const { mapCtaButtonImage } = useMapCtaButtonImage({ distributor });

  if (!mapCtaButtonImage) return null;

  return (
    <Image
      className={clsx(
        'h-auto',
        'rounded-none',
        'bg-inherit',
        'filter-[drop-shadow(0_4px_4px_rgba(0,0,0,0.25))]',
        'shadow-none',
        'pointer-events-auto',
        'cursor-pointer',
      )}
      onClick={() => {
        amplitude.map_CTAButton_click();
        onClick();
      }}
      width={60}
      height={80}
      src={mapCtaButtonImage}
      alt="map-cta-button"
    />
  );
};
